<mce-page-with-navigation>
  <div class="grid gap-4 md:grid-cols-2" [attr.test-id]="'dashboard'">

    @if (viewState().showMotd){
    <div class="motd min-w-0">
      <mce-info-message type="error">
        <div class="mb-2 flex justify-end">
          <button type="button" class="text-sm underline" aria-label="Dismiss message of the day" (click)="dismissMotd()">Dismiss</button>
        </div>
        <div [innerHTML]="viewState().motd" class="mb-4"></div>
      </mce-info-message>
    </div>}

    <div class="recent min-w-0">
      <mce-projects-status></mce-projects-status>
    </div>

    <div class="metals min-w-0">
      <mce-metal-prices></mce-metal-prices>
    </div>

    <div class="standards min-w-0">
      <app-standards-reference></app-standards-reference>
    </div>

    <div class="equipment min-w-0">
      <app-equipment-data></app-equipment-data>
    </div>

  </div>
</mce-page-with-navigation>



